import { createI18n } from 'vue-i18n';
import ar from './langs/ar.json';
import en from './langs/en.json';

function loadLocaleMessages() {
  return {
    en,
    ar
  };
}

const savedLocale = localStorage.getItem('locale') || 'en';

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});

export default i18n;